import OrderItemShippingMethodModal from './OrderItemShippingMethodModal'

export default OrderItemShippingMethodModal
